import { createContext, useContext, useState, ReactNode } from "react";
import { Dialog } from "primereact/dialog";

interface DialogOptions {
  name: string; // 🔥 required
  header?: string;
  content?: ReactNode;
  style?: React.CSSProperties;
}

interface DialogContextType {
  openDialog: (options: DialogOptions) => void;
  closeDialog: (name: string) => void;
}

const DialogContext = createContext<DialogContextType | null>(null);

export const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [dialogs, setDialogs] = useState<DialogOptions[]>([]);

  const openDialog = (options: DialogOptions) => {
    setDialogs((prev) => {
      // ✅ if already exists → replace (optional behavior)
      const exists = prev.find((d) => d.name === options.name);

      if (exists) {
        return prev.map((d) =>
          d.name === options.name ? options : d
        );
      }

      return [...prev, options];
    });
  };

  const closeDialog = (name: string) => {
    setDialogs((prev) => prev.filter((d) => d.name !== name));
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}

      {dialogs.map((dialog, index) => (
        <Dialog
          className="dialogBoxStyle"
          key={dialog.name}
          header={dialog.header}
          visible={true}
          onHide={() => closeDialog(dialog.name)}
          style={dialog.style || { width: "40vw" }}
          modal
          baseZIndex={1000 + index * 100}
        >
          {dialog.content}
        </Dialog>
      ))}
    </DialogContext.Provider>
  );
};

export const useGlobalDialog = () => {
  const context = useContext(DialogContext);
  if (!context) throw new Error("Wrap app with DialogProvider");
  return context;
};